define('views/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/calendar/session/animation',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MAnimation,
    // views
    VBasePanel,
    VExerciseEditContent
) {

    var VCustomExerciseEditPanel = VBasePanel.extend({
        header: {
            title: "calendar:Custom exercises",
            subtitle: "calendar:Adding/Modify a custom exercise",
        },
        content: {
            edit: VExerciseEditContent
        },
        tabs: [{ id: 'edit', title: 'Edit', active: true }],
        defaultView: 'edit',

        initialize: function(opt) {
            opt = opt || {};
            this.model = new MAnimation();
            var edit = this.getView('edit', {
                model: this.model,
                group: opt.group
            });
            this.listenTo(edit, { 'form:success': this.onSuccess });
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            this.model.fetch();
            return this;
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            return this;
        },

        onSuccess: function(model) {
            this.trigger('form:success', model);
            this.close();
        },

    });

    return VCustomExerciseEditPanel;

});

